<template>
  <div v-if="loading">
    <oil-cap
        :title="'Арендованные автомобили'.toUpperCase()"
        :buttons="[
                  {
                    route: 'vehicle-hire',
                    name: 'добавить автомобиль'
                  }
        ]"
    />
    <v-divider class="mt-2 mb-2"/>
    <oil-table
        :items="vehicles"
        :keys="[
          {text:'название',value:'Name'},
          {text:'модель',value:'Model'},
          {text:'гос. номер',value:'ModelRegistrationNumber'},
          {text:'литраж',value:'Volume'},
          {text:'статус',value:'Status'},
          {text:'',value:'Id'},
      ]"
    >

      <template v-slot:Id="{value}">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs"
                   v-on="on" icon
                   @click.stop="rowClick(value)">
              <v-icon color="primary">
                mdi-pen
              </v-icon>
            </v-btn>
          </template>
          <span>РЕДАКТИ́РОВАТЬ</span>
        </v-tooltip>
      </template>
      <template v-slot:Status="{value}">
        <v-chip :color="status[value].color">
          {{ status[value].value }}
        </v-chip>
      </template>

    </oil-table>
  </div>

</template>

<script>
import {vehicleService} from "@/services/VehicleService";

export default {
  data: () => ({
    loading: false,
    vehicles: [],
    status: {
      active: {value: 'Активный', color: 'green'},
      inactive: {value: 'Неактивный', color: 'red'},
    }
  }),
  components: {
    OilTable: () => import('@/components/helper/oil.table'),
    OilCap: () => import('@/components/helper/oil.cap'),
  },
  async created() {
    const vehicles = await vehicleService.getAllOwners({isOwn: false})
    this.vehicles = vehicles.data
    this.loading = true
  },
  methods: {
    rowClick(Id) {
      this.$router.push({
        name: 'vehicle-hire',
        params: {id: Id}
      })
    }
  }
}
</script>

<style>

</style>
